/** Spring CookieCsrfTokenRepository + SpaCsrfTokenRequestHandler: cookie XSRF-TOKEN, header X-XSRF-TOKEN. */
const CSRF_COOKIE_NAME = 'XSRF-TOKEN';
const CSRF_HEADER_NAME = 'X-XSRF-TOKEN';
const CSRF_METHODS = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);

function readXsrfTokenFromCookie(): string | undefined {
    const prefix = `${CSRF_COOKIE_NAME}=`;
    const parts = `; ${document.cookie}`.split(`; ${prefix}`);
    if (parts.length !== 2) {
        return undefined;
    }
    const raw = parts.pop()?.split(';').shift();
    return raw ? decodeURIComponent(raw) : undefined;
}

export function withCsrfHeaders(
    method: string | undefined,
    headers: Record<string, string> = {}
): Record<string, string> {
    const merged: Record<string, string> = {...headers};
    if (!CSRF_METHODS.has((method || 'GET').toUpperCase())) {
        return merged;
    }
    const token = readXsrfTokenFromCookie();
    if (token && merged[CSRF_HEADER_NAME] === undefined) {
        merged[CSRF_HEADER_NAME] = token;
    }
    return merged;
}
